export default "__VITE_ASSET__BiqcXRny__"